document.addEventListener('DOMContentLoaded', function () {
  const productThumbnails = new Swiper('.product-thumbnails', {
    spaceBetween: 20,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.thumbnails-button-next',
      prevEl: '.thumbnails-button-prev',
    },
  });

  const productGallery = new Swiper('.product-gallery', {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.gallery-button-next',
      prevEl: '.gallery-button-prev',
    },
    thumbs: {
      swiper: productThumbnails,
    },
  });

  // const imageCarousel = new Swiper('.image-carousel', {
  //   spaceBetween: 20,
  //   loop: true,
  //   autoplay: {
  //     delay: 3000,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1,
  //   breakpoints: {
  //     640: {
  //       slidesPerView: 2,
  //     },
  //     768: {
  //       slidesPerView: 3,
  //     },
  //     1024: {
  //       slidesPerView: 4,
  //     },
  //   }
  // });

  // const marqueeSlider = new Swiper('.marquee-scroller', {
  //   spaceBetween: 0,
  //   speed: 5000,
  //   spaceBetween: 20,
  //   pauseOnMouseEnter: true,
  //   autoplay: {
  //     delay: 0,
  //     disableOnInteraction: true,
  //   },
  //   loop: true,
  //   slidesPerView: 5,
  //   freeMode: true,
  //   freeModeMomentum: false,
    
  //   breakpoints: {
  //     640: {
  //       slidesPerView: 5,
  //     },    
  //     768: {
  //       slidesPerView: 5,
  //     },
  //     1024: {
  //       slidesPerView: 6,
  //     },
  //     1200: {
  //       slidesPerView: 7,
  //     },
  //   }
  // });

  const labelScroller = new Swiper('.label-scroller-swiper', {
    spaceBetween: 20,
    speed: 10000,
    loop: true,
    autoplay: {
      delay: 0,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    slidesPerView: 2,
    freeMode: true,
    freeModeMomentum: false,
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 4,
      },
    }
  });
});